module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "academy-search"
  }, [_c('h2', {}, [_vm._v("Academy Search")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.extCompRef),
      expression: "extCompRef"
    }],
    staticClass: "text-input bg-white",
    attrs: {
      "type": "text",
      "placeholder": "extCompRef"
    },
    domProps: {
      "value": _vm._s(_vm.extCompRef)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.extCompRef = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("and/or")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.acadid),
      expression: "acadid"
    }],
    staticClass: "text-input bg-white",
    attrs: {
      "type": "text",
      "placeholder": "Schoox Academy ID"
    },
    domProps: {
      "value": _vm._s(_vm.acadid)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.acadid = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button raised",
    on: {
      "click": _vm.search
    }
  }, [_vm._v("Search")])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.err),
      expression: "err"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.err))]), _vm._v(" "), (_vm.searched) ? _c('div', {
    staticClass: "search-results"
  }, [_c('h3', [_vm._v("Search Results")]), _vm._v(" "), (_vm.resultsCount == 0) ? _c('div', [_c('p', [_vm._v("No records found")])]) : _c('div', [_c('div', [_c('v-client-table', {
    attrs: {
      "data": _vm.tableData,
      "columns": _vm.columns,
      "options": _vm.options
    }
  })])]), _vm._v(" ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "search-results"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-24a38d93!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AcademySearch.vue
// module id = 407
// module chunks = 2